/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uCode = A4uCode;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uCode(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M35.493,19.061,27.3,27.381a1,1,0,0,1-1.425,0l-.893-.907a1.006,1.006,0,0,1,0-1.4L31.943,18l-6.959-7.071a1.006,1.006,0,0,1,0-1.4l.893-.907a1,1,0,0,1,1.425,0l8.191,8.32A1.523,1.523,0,0,1,35.493,19.061Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M.507,16.939,8.7,8.619a1,1,0,0,1,1.425,0l.893.907a1.006,1.006,0,0,1,0,1.4L4.057,18l6.959,7.071a1.006,1.006,0,0,1,0,1.4l-.893.907a1,1,0,0,1-1.425,0L.507,19.061A1.523,1.523,0,0,1,.507,16.939Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M15.489,29.687H14.345a1,1,0,0,1-.966-1.259L19.571,5.387a1,1,0,0,1,.966-.741h1.105A1,1,0,0,1,22.608,5.9L16.455,28.946A1,1,0,0,1,15.489,29.687Z"
  }));
}